import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

export interface PercentageDialogProps {
  open: boolean;
  onFeedback: Function;
}

export const PercentageDialog: React.FC<PercentageDialogProps> = ({
  open,
  onFeedback,
}) => {
  const intl = useIntl();
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {intl.formatMessage({
          id: 'builder.moduleeditor.progressdialog.title',
          defaultMessage: 'Prozentangaben automatisch berechnen',
        })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {intl.formatMessage({
            id: 'builder.moduleeditor.progressdialog.description',
            defaultMessage:
              'Hinweis: Alle manuell eingegebenen Prozentangaben werden überschrieben.',
          })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onFeedback('ok')}>
          {intl.formatMessage({
            id: 'builder.moduleeditor.progressdialog.confirm',
            defaultMessage: 'Ok',
          })}
        </Button>
        <Button onClick={() => onFeedback('cancel')} autoFocus>
          {intl.formatMessage({
            id: 'builder.moduleeditor.progressdialog.cancel',
            defaultMessage: 'Abbrechen',
          })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
